import "core-js/modules/es.error.cause.js";
import { mapState } from 'vuex';
import { getPhoneCode } from '@/api/user';
export default {
  props: {
    way: {
      type: String,
      default: 'logOff'
    },
    visibleEditModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeKey: '1',
      accountForm: {
        password: ''
      },
      mobileForm: {
        code: ''
      },
      text: '获取验证码',
      timer: null,
      time: 60,
      disable: false,
      showPassword: false,
      isEyeOpen: false,
      passwordVisible: false
    };
  },
  computed: {
    ...mapState({
      accountInfo: state => state.user.accountInfo
    }),
    encryMobile() {
      return this.accountInfo.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },
    rules() {
      return {
        password: [{
          required: true,
          message: this.$t('请输入') + this.$t('密码'),
          trigger: 'blur'
        }],
        code: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error(this.$t('请输入') + this.$t('验证码')));
            } else if (value.length > 0 && value.length < 6) {
              callback(new Error(this.$t('验证码错误，请重新输入')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }]
      };
    },
    textLength() {
      return this.$t(this.text).length;
    }
  },
  watch: {
    visibleEditModal(val) {
      console.log(val, '------visibleEditModal val-------');
      if (val) {
        var _this$$refs$ruleForm, _this$$refs$mobileRul;
        this.activeKey = '1';
        this.accountForm.password = '';
        this.mobileForm.code = '';
        (_this$$refs$ruleForm = this.$refs.ruleForm) === null || _this$$refs$ruleForm === void 0 || _this$$refs$ruleForm.clearValidate();
        (_this$$refs$mobileRul = this.$refs.mobileRuleForm) === null || _this$$refs$mobileRul === void 0 || _this$$refs$mobileRul.clearValidate();
        this.isEyeOpen = false; // 关闭 modal 时关闭小眼睛
        this.passwordVisible = false;
        this.text = '获取验证码';
        console.log(this.isEyeOpen, this.passwordVisible, '-----this.isEyeOpen------');
      }
    }
  },
  mounted() {},
  destroyed() {
    // clearInterval(this.timer);
  },
  methods: {
    tabChange(key) {
      var _this$$refs$ruleForm2, _this$$refs$mobileRul2;
      this.activeKey = key;
      // 清空数据
      this.accountForm.password = '';
      this.mobileForm.code = '';
      // 清空错误校验
      console.log(this.$refs, '-----this.$refs.ruleForm------');
      (_this$$refs$ruleForm2 = this.$refs.ruleForm) === null || _this$$refs$ruleForm2 === void 0 || _this$$refs$ruleForm2.clearValidate();
      (_this$$refs$mobileRul2 = this.$refs.mobileRuleForm) === null || _this$$refs$mobileRul2 === void 0 || _this$$refs$mobileRul2.clearValidate();
    },
    handleBlurTrim(key, e) {
      if (key === 'code') {
        this.mobileForm[key] = this.mobileForm[key].trim();
      } else if (key === 'password') {
        this.accountForm[key] = this.accountForm[key].trim();
      }
    },
    codeInput(key, e) {
      this.mobileForm[key] = e.target.value.replace(/[^0-9]/g, '');
    },
    // 获取验证码
    getCode() {
      if (this.accountInfo.mobile) {
        // 获取手机号，发送验证码
        getPhoneCode({
          mobile: this.accountInfo.mobile,
          way: this.way,
          globalRoaming: this.accountInfo.globalRoaming
        }).then(res => {
          console.log(res, '------code res-------');
          this.verifyCodeInterval();
        });
      }
    },
    verifyCodeInterval() {
      this.text = `${this.time}s`;
      this.disable = true;
      this.timer = setInterval(() => {
        this.time--;
        this.text = `${this.time}s`;
        if (this.time === 0) {
          clearInterval(this.timer);
          this.text = '重新发送';
          this.time = 60;
          this.disable = false;
        }
      }, 1000);
      this.$refs.code.focus();
    }
  }
};